//@ts-check
import { DateTime } from 'luxon'
export default class StandardDates {

    /**
     * Converts a JavaScript Date object to an ISO date string (YYYY-MM-DD).
     * @param {Date} date - The date to convert.
     * @returns {string|null} - The ISO date string or null if the date is invalid.
     */
    static toISODate(date) {
        if (!date) return null
        const dt = DateTime.fromJSDate(date)
        return dt.isValid ? dt.toISODate() : null
    }

    /**
     * Converts an ISO date string (YYYY-MM-DD) to a JavaScript Date object.
     * @param {string} isoString - The ISO date string to convert.
     * @returns {DateTime|null} - The JavaScript Date object or null if the string is invalid.
     */
    static fromISODate(isoString) {
        if (!isoString) return null
        const dt = DateTime.fromISO(isoString)
        return dt.isValid ? dt : null
    }

    /**
     * Formats a JavaScript Date object into a string based on the provided format.
     * @param {string} date - The date to format.
     * @param {string} fromFormat - The desired format (default is 'dd/MM/yyyy').
     * @param {string} toFormat 
     * @returns {string|null} - The formatted date string or null if the date is invalid.
     */
    static fromFormatDate(date, toFormat, fromFormat = 'dd/MM/yyyy') {
        if (!date || !fromFormat || !toFormat) return null
        const dt = DateTime.fromFormat(date, fromFormat)
        return dt.isValid ? dt.toFormat(toFormat) : null
    }


}